export class MouseState {
  x: number;
  y: number;
  scale: number;
  isDown: boolean;
  //clientX: number;
  //clientY: number;

  //get absoluteX(): number {
  //  return this.clientX / this.scale;
  //}
  //get absoluteY(): number {
  //  return this.clientY / this.scale;
  //}
}
